import { render, staticRenderFns } from "./NewTable.vue?vue&type=template&id=36c18395"
import script from "./NewTable.vue?vue&type=script&lang=js"
export * from "./NewTable.vue?vue&type=script&lang=js"
import style0 from "./NewTable.vue?vue&type=style&index=0&id=36c18395&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports